import styled from 'styled-components'

export const Video = styled.video`
  max-width: 30rem;
  display: block;
  margin: auto;
`

Video.displayName = 'VideoPreview'
